import React from "react";
import Slider from "react-slick";
import dummyImg from "../../images/no-image-thumb.jpg";
import generateSlug from "../common/generateSlug";
import { Link } from "react-router-dom";

const NewPremiumProjects = ({
  premiumProjects,
  user,
  token,
  wishlist,
  handleDispatch,
  category,
}) => {
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="custom-arrow-show-premium premium-next-arrow"
        onClick={onClick}
        aria-label="Next"
      >
        ❯
      </button>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="custom-arrow-show-premium premium-prev-arrow"
        onClick={onClick}
        aria-label="Previous"
      >
        ❮
      </button>
    );
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, // 1 second = 1000ms
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
    ],
  };

  const handleLinkClick = (project) => {
    const url = generateSlug(project);
    const propertyIds = project?.property_ids;
    localStorage.setItem(
      "last-property-seen",
      JSON.stringify({ id: propertyIds, typeWithId: url })
    );
    window.location.href = url; // Navigate manually
  };

  const premium = {
    buy: {
      link: "/buy/searches/flats-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Desc",
    },
    commercial: {
      link: "/commercial/buy/searches/commerical-property-for-sale-in-jaipur-rajasthan-srcid-1",
    },
    plot: {
      link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Desc",
      localStorageFeatures: "property_type:plot",
    },
  };
  const premiumStyles = premium[category];
  return (
    <>
      <section className="afford-section sectiontopgap ">
        <div className="container premium-section">
          <div className="row">
            <div className="col-md-7 col-12" style={{ margin: "36px 0px" }}>
              <div className="premium-detail-section">
                <div className="sectiontitle" style={{ textAlign: "left" }}>
                  <div className="titleunderline" data-aos="fade-right">
                    <svg
                      width="64"
                      height="3"
                      viewBox="0 0 64 3"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 1.5H62"
                        stroke="#FFFFFF"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <h1 style={{ color: "#FFFFFF", fontSize: "26px" }}>
                    Premium Projects
                  </h1>
                </div>
                <p className="premium-description mb-4 mt-4">
                  Experience the art of refined living in Jaipur’s most coveted
                  spaces. Each project is a masterpiece — where luxury meets
                  thoughtful design, crafted to elevate everyday life.
                </p>
                <div className="premiumButton">
                  <Link
                    to={premiumStyles.link}
                    onClick={() => {
                      if (premiumStyles.localStorageKey) {
                        localStorage.setItem(
                          "sort_clicked",
                          premiumStyles.localStorageKey
                        );
                      }
                      if (premiumStyles.localStorageFeatures) {
                        localStorage.setItem(
                          "feature_clicked",
                          premiumStyles.localStorageFeatures
                        );
                      }
                    }}
                  >
                    <button className="btn" type="button">
                      <span>Explore</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-5 col-12">
              <div class="hero-section">
                <div class="card-wrapper">
                  <div class="card-shadow"></div>
                  <Slider {...settings}>
                    {premiumProjects.map((data, index) => (
                      <div
                        class="swiper mySwiper"
                        onClick={() => handleLinkClick(data)}
                      >
                        <div class="swiper-wrapper">
                          <div class="swiper-slide">
                            <img
                              src={data?.images?.[0] ?? dummyImg}
                              alt="Property"
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = dummyImg;
                              }}
                            />

                            <div class="overlay-text">{data?.project_name}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewPremiumProjects;
